module.exports = __webpack_public_path__ + "static/media/EmptyCart.d3cdba5b.png";